import { AuthorHeroPropsWithSEO } from "~/components/AuthorHero";
import { AuthorPage } from "~/components/AuthorPage/";
import { PageMeta } from "~/components/PageMeta";
import {
  ReadMorePostsProps,
  apiToReadMorePosts,
} from "~/components/ReadMorePosts";
import { fetchAuthor } from "~/lib/server/asgardApiCalls";
import { createGetStaticPathsForPosts } from "~/lib/server/createGetStaticPathsForPosts";
import { fetchPosts } from "~/lib/server/fetchPosts";
import { wrapGetStaticProps } from "~/lib/server/wrapGetProps";
import { apiAuthorDetailsToProps } from "~/lib/shared/apiAuthorToProps";
import { PostTypeEnum } from "~/types/asgard/PostType";

export interface AuthorsPageProps {
  authorHeroProps: AuthorHeroPropsWithSEO;
  readMorePostsProps: Omit<ReadMorePostsProps, "renderItems">;
}

export type AuthorPageParams = {
  authorSlug: string;
};

export const getStaticPaths = createGetStaticPathsForPosts(
  null,
  PostTypeEnum.Author,
  "authors"
);

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 12;

export const getStaticProps = wrapGetStaticProps<
  AuthorsPageProps,
  AuthorPageParams
>(async ({ params }) => {
  const { authorSlug } = params!;
  const { data: authorData } = await fetchAuthor(authorSlug);
  const { posts: rawPosts, totalPages } = await fetchPosts({
    authorFilter: authorSlug,
    currentPage: DEFAULT_PAGE,
    pageSize: DEFAULT_PAGE_SIZE,
  });
  const authorHeroProps = apiAuthorDetailsToProps(authorData);

  return {
    props: {
      authorHeroProps,
      readMorePostsProps: {
        usePaginatedPostsConfig: {
          authorFilter: authorSlug,
          pageSize: DEFAULT_PAGE_SIZE,
        },
        defaultItems: apiToReadMorePosts(rawPosts),
        totalPages,
      },
      meta: { piano: { type: "list", tags: [] } },
    },
  };
});

export default function AuthorsPage({
  authorHeroProps,
  readMorePostsProps,
}: AuthorsPageProps) {
  return (
    <>
      <PageMeta
        seo={authorHeroProps?.seo}
        structuredData={authorHeroProps?.structuredData}
      />
      <AuthorPage
        authorHeroProps={authorHeroProps}
        readMorePostsProps={readMorePostsProps}
      />
    </>
  );
}
